import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LotViewsFragment } from 'src/app/modules/graphql/service/graphql-auto-main-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lot-views',
  templateUrl: './lot-views.component.html',
  styleUrls: ['./lot-views.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotViewsComponent {
  @Input()
  set lot(lot: LotViewsFragment) {
    this.views = lot.lotSourceViews || [];
  }

  views: LotViewsFragment['lotSourceViews'] = [];
  managerDomain = environment.managerDomain;
}
